import {PortalStates} from "../../States";

/**
 * update user handler
 * @param payload
 * @returns {*}
 */
export function UpdatePortal(payload) {
  if (payload) localStorage.setItem("portalReducer", JSON.stringify(payload));
  else localStorage.removeItem("portalReducer");

  if (payload)
    return {
      type: PortalStates.SUCCESS,
      payload,
    };

  return {
    type: PortalStates.DELETE,
    payload,
  };
}
